{
  "$id": "wealthlane://forms/performance-rule/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "performance_rule_identity",
      "fields": [
        {
          "scope": "#/properties/ruleName",
          "field": "#/properties/ruleName",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 280,
          "maxWidthPx": 640
        },
        {
          "scope": "#/properties/ruleTypeId",
          "field": "#/properties/ruleTypeId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        },
        {
          "scope": "#/properties/isAvailable",
          "field": "#/properties/isAvailable",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true,
          "style": { "--ui-checkbox-label-size": "13px", "--ui-checkbox-label-lh": "1.4" }
        }
      ]
    },
    {
      "rowId": "performance_rule_evaluation_period",
      "title": "Evaluation Period",
      "titleStyle": "lozenge",
      "lozengeVariant": "info",
      "fields": [
        {
          "scope": "#/properties/evaluationPeriodStartDate",
          "field": "#/properties/evaluationPeriodStartDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 180,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/evaluationPeriodEndDate",
          "field": "#/properties/evaluationPeriodEndDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 180,
          "maxWidthPx": 320
        }
      ]
    },
    {
      "rowId": "performance_rule_multiplier_range",
      "title": "Multiplier Range",
      "titleStyle": "lozenge",
      "lozengeVariant": "info",
      "fields": [
        {
          "scope": "#/properties/minimumPercentage",
          "field": "#/properties/minimumPercentage",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 280
        },
        {
          "scope": "#/properties/maximumPercentage",
          "field": "#/properties/maximumPercentage",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 280
        }
      ]
    },
    {
      "rowId": "performance_rule_descriptions",
      "fields": [
        {
          "scope": "#/properties/ruleDescription",
          "field": "#/properties/ruleDescription",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 280,
          "maxWidthPx": 800
        },
        {
          "scope": "#/properties/ruleSummary",
          "field": "#/properties/ruleSummary",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 280,
          "maxWidthPx": 800,
          "startNewRow": true
        },
        {
          "scope": "#/properties/showRuleDisplayToParticipant",
          "field": "#/properties/showRuleDisplayToParticipant",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true,
          "style": { "--ui-checkbox-label-size": "13px", "--ui-checkbox-label-lh": "1.4" }
        }
      ]
    },
    {
      "rowId": "performance_rule_tracking_section",
      "title": "Estimate Performance Tracking",
      "titleSpacing": "compact",
      "fields": [
        {
          "scope": "#/properties/showPerformanceTrackingToParticipant",
          "field": "#/properties/showPerformanceTrackingToParticipant",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 280,
          "maxWidthPx": 800,
          "style": { "--ui-checkbox-label-size": "13px", "--ui-checkbox-label-lh": "1.4" }
        }
      ]
    },
    {
      "type": "each",
      "field": "#/properties/estimatePerformanceTrackings",
      "presentation": "table",
      "rowId": "performance_rule_tracking_table",
      "addButton": {
        "label": "Add Tracking Row",
        "variant": "primary",
        "icon": "add",
        "position": "bottom-left"
      },
      "removeButton": {
        "icon": "delete",
        "variant": "inline-icon"
      },
      "tableHeaderStyle": "banded",
      "itemFields": [
        {
          "name": "trackingDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 150,
          "maxWidthPx": 160
        },
        {
          "name": "multiplierPercentage",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 88,
          "maxWidthPx": 100
        },
        {
          "name": "comment",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 100,
          "maxWidthPx": 240
        }
      ]
    },
    {
      "rowId": "performance_rule_final_evaluation",
      "title": "Final Evaluation",
      "titleSpacing": "compact",
      "fields": [
        {
          "scope": "#/properties/performanceEvaluation/properties/evaluationDate",
          "field": "#/properties/performanceEvaluation/properties/evaluationDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 220,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/performanceEvaluation/properties/earnedMultipier",
          "field": "#/properties/performanceEvaluation/properties/earnedMultipier",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 220,
          "maxWidthPx": 320
        }
      ]
    }
  ]
}
